import {zIndexEditBoxKnob} from 'crazyEditor/core/globals';
const knobOffset = '-5px';
const knobSize = '8px';

export default {
  knob: {
    position: 'absolute',
    backgroundColor: '#fff',
    height: knobSize,
    width: knobSize,
    border: '1px solid #000',
    borderRadius: '50%',
    zIndex: zIndexEditBoxKnob,
  },
  knobTopLeft: {
    top: knobOffset,
    left: knobOffset,
    cursor: 'nw-resize'
  },
  knobTopRight: {
    top: knobOffset,
    right: knobOffset,
    cursor: 'ne-resize'
  },
  knobMiddleLeft: {
    top: `calc(50% + ${knobOffset})`,
    left: knobOffset,
    cursor: 'w-resize'
  },
  knobMiddleRight: {
    top: `calc(50% + ${knobOffset})`,
    right: knobOffset,
    cursor: 'e-resize'
  },
  knobBottomLeft: {
    bottom: knobOffset,
    left: knobOffset,
    cursor: 'sw-resize'
  },
  knobBottomRight: {
    bottom: knobOffset,
    right: knobOffset,
    cursor: 'se-resize'
  },
  knobTopMiddle: {
    top: knobOffset,
    left: `calc(50% + ${knobOffset})`,
    cursor: 'n-resize'
  },
  knobBottomMiddle: {
    bottom: knobOffset,
    left: `calc(50% + ${knobOffset})`,
    cursor: 's-resize'
  }
};
